import React from 'react';
import { Bell, X } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Modal shown after the user creates their first engagement,
 * prompting them to enable push notifications.
 * Purely presentational — parent handles subscribe() call.
 */
const PushPermissionModal = ({ open, onEnable, onLater, loading }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[110] bg-atlasBg/90 backdrop-blur-sm flex items-center justify-center p-6"
         data-testid="push-permission-modal">
      <div className="glass-card p-6 w-full max-w-md relative">
        <button
          onClick={onLater}
          className="absolute top-4 right-4 p-1 text-atlasTextSecondary hover:text-white"
          data-testid="push-modal-close"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="flex items-center justify-center w-14 h-14 rounded-full bg-atlasCyan/10 border border-atlasCyan/30 mb-4">
          <Bell className="w-7 h-7 text-atlasCyan" />
        </div>

        <h2 className="text-xl font-bold text-white mb-2">
          Pour qu'ATLAS te rappelle ton engagement
        </h2>
        <p className="text-sm text-atlasTextSecondary leading-relaxed mb-6">
          Active les notifications. ATLAS te préviendra 3 minutes avant chaque engagement,
          même quand l'app est fermée.
        </p>

        <div className="flex flex-col gap-2">
          <Button
            data-testid="push-enable-btn"
            onClick={onEnable}
            disabled={loading}
            className="w-full btn-primary"
          >
            {loading ? 'Activation…' : 'Activer les notifications'}
          </Button>
          <Button
            data-testid="push-later-btn"
            variant="ghost"
            onClick={onLater}
            className="w-full text-atlasTextSecondary hover:text-white"
          >
            Plus tard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PushPermissionModal;
